import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/api";

import { Login } from "@/pages/login";
import { RequestAccess } from "@/pages/request-access";
import { PortalLayout } from "@/components/layout/portal-layout";
import { Dashboard } from "@/pages/accountant/dashboard";
import { InviteClients } from "@/pages/accountant/invite";
import { ClientDetail } from "@/pages/accountant/client-detail";
import { ReviewRoute } from "@/pages/accountant/review";
import { Settings } from "@/pages/accountant/settings";
import { Help } from "@/pages/accountant/help";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { OfflineBanner } from "@/components/shared/offline-banner";

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <OfflineBanner />
          <Toaster richColors closeButton />
          <Routes>
            {/* Shared auth routes (no prefix) */}
            <Route path="/login" element={<Login />} />
            <Route path="/request-access" element={<RequestAccess />} />

            {/* Accountant routes (under /accountant/ prefix) */}
            <Route path="/accountant" element={<PortalLayout />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="invite" element={<InviteClients />} />
              <Route path="clients/:id" element={<ClientDetail />} />
              <Route path="clients/:id/review" element={<ReviewRoute />} />
              <Route path="settings" element={<Settings />} />
              <Route path="help" element={<Help />} />
            </Route>

            {/* Default redirect */}
            <Route
              path="*"
              element={<Navigate to="/accountant/dashboard" replace />}
            />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
